export const validateNumberInput = (value: string, decimalDigits = 2) => {
   // Create a dynamic regex pattern based on the decimalDigits parameter
   const regex = new RegExp(`^\\d+((\\.|,)\\d{1,${decimalDigits}})?$`);
   // Return Input only if it is a valid number
   return regex.test(value);
}

export const formatNumberInput = (value: string | undefined) => {
  if (!value && value !== "") {
    return "0,00";
  }
  return value.replace(/^0+(?!(\.|,|$))/m, "").replaceAll(".", ",");
}